import { useLocation } from 'react-router-dom'

import { AllProductToursDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'

export type GetProductToursProps = {
  ids?: string[]
  preview?: boolean
  title?: string
}

export const useGetProductTours = (variables: GetProductToursProps) => {
  const { company } = useCurrentSession()
  const mainLegalEntity = company.legalEntities.find((legalEntity) => legalEntity.main)
  const { search } = useLocation()
  const locale = getDatoLocale(mainLegalEntity?.country ?? '')
  const preview = new URLSearchParams(search).get('preview') === 'true'
  const { data, loading } = useQuery(AllProductToursDocument, {
    variables: { ...variables, preview, locale },
  })

  return {
    loading,
    productTours: data?.productUpdates.productToursConnection.nodes,
  }
}
